import { jsxs, jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Image } from "@zillow/constellation-10";
import { withPreload, Source, Picture as Picture$1 } from "@zillow/zrs-cms";
import React from "react";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
import StructuredData from "../../components/StructuredData/StructuredData.esm.js";
import { withAnchor } from "../../util/helpers.esm.js";
const SourcePreload = withPreload(Source);
const ImagePreload = withPreload(Image);
const CSS_VAR_DESKTOP = "--cms-picture-width";
const CSS_VAR_TABLET = "--cms-picture-width-tablet";
const CSS_VAR_MOBILE = "--cms-picture-width-mobile";
const responsiveImageClass = css({
  maxWidth: "100%",
  height: "auto",
  width: `var(${CSS_VAR_DESKTOP}, auto)`,
  "@media (max-width: 1023px) and (min-width: 481px)": {
    width: `var(${CSS_VAR_TABLET}, var(${CSS_VAR_DESKTOP}, auto))`
  },
  "@media (max-width: 480px)": {
    width: `var(${CSS_VAR_MOBILE}, var(${CSS_VAR_DESKTOP}, auto))`
  },
  // The v8 Image rendered as a default inline <img>, so editors centered
  // pictures through an ancestor's text-align (e.g. Card textAlign). The v10
  // Image forces display: block, which flushes narrower-than-container
  // images left. The doubled :is(img) outranks v10's `.class:is(img)` rule
  // (0,1,2 vs 0,1,1) without depending on stylesheet order.
  "&:is(img):is(img)": {
    display: "inline"
  }
});
const toPx = (value) => {
  if (value === void 0 || value === null || value === "") return void 0;
  return typeof value === "number" ? `${value}px` : value;
};
const buildWidthVars = (desktop, tablet, mobile) => {
  const vars = {
    [CSS_VAR_DESKTOP]: toPx(desktop == null ? void 0 : desktop.width),
    [CSS_VAR_TABLET]: toPx(tablet == null ? void 0 : tablet.width),
    [CSS_VAR_MOBILE]: toPx(mobile == null ? void 0 : mobile.width)
  };
  return vars;
};
const BlockPicture = ({
  attrs,
  index
}) => {
  const {
    desktop,
    tablet,
    mobile,
    loading = "lazy",
    decoding = "async",
    margin = {}
  } = attrs;
  const structuredData = [desktop, tablet, mobile].filter((picture) => Boolean(picture == null ? void 0 : picture.src)).map((picture) => ({
    "@context": "https://schema.org/",
    "@type": "ImageObject",
    contentUrl: picture.src,
    caption: picture.alt,
    height: picture.height,
    width: picture.width
  }));
  const isPost = usePlacement() === "post";
  const widthVars = buildWidthVars(desktop, tablet, mobile);
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsx(StructuredData, { data: structuredData }),
    /* @__PURE__ */ jsxs(Picture$1, { ...isPost ? {
      marginBottom: "md"
    } : margin, children: [
      mobile && /* @__PURE__ */ jsx(SourcePreload, { srcSet: mobile.src, width: mobile.width, height: mobile.height, loading, decoding, media: "sm_lte" }),
      tablet && /* @__PURE__ */ jsx(SourcePreload, { srcSet: tablet.src, width: tablet.width, height: tablet.height, loading, decoding, media: "lg_lte" }),
      desktop && /* @__PURE__ */ jsx(ImagePreload, { src: desktop.src, width: desktop.width, height: desktop.height, alt: desktop.alt, loading, decoding, className: responsiveImageClass, style: widthVars })
    ] }, index)
  ] });
};
const Picture = withAnchor(BlockPicture);
export {
  Picture as default
};
